import { render, staticRenderFns } from "./distributorEdit.vue?vue&type=template&id=56958e53&"
import script from "./distributorEdit.vue?vue&type=script&lang=js&"
export * from "./distributorEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports